var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ilustraci\xF3n / Herramientas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Explorations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LG-Consola-Login",
    transform: "translate(-364.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-Container",
    transform: "translate(285.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ilustraci\\xF3n-/-Herramientas",
    transform: "translate(79.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.289375,117.87375 L120.99875,55.164375 C131.251875,59.1815625 143.354375,57.05375 151.638437,48.769375 C159.920312,40.4875 162.048437,28.3846875 158.033437,18.1296875 L143.566562,32.5965625 L130.81875,29.1825 L127.404687,16.4346875 L141.871562,1.9678125 C131.61625,-2.0471875 119.51375,0.080625 111.231875,8.3628125 C102.947812,16.646875 100.819687,28.7496875 104.836875,39.0025 L42.1275,101.711875 C31.0965625,97.0625 17.8715625,99.2303125 8.8846875,108.217188 C-2.9615625,120.063438 -2.9615625,139.270313 8.8846875,151.116563 C20.7309375,162.962813 39.9378125,162.962813 51.7840625,151.116563 C60.7709375,142.129688 62.93875,128.904375 58.289375,117.87375 Z M22.2534375,137.747813 C17.7896875,133.284063 17.791875,126.0475 22.2534375,121.585938 C26.7171875,117.122188 33.9515625,117.1225 38.4153125,121.585938 C42.8790625,126.049375 42.8790625,133.284063 38.4153125,137.747813 C33.95375,142.209063 26.7171875,142.21125 22.2534375,137.747813 Z",
    id: "Shape",
    fill: "#F0F8FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7840625,151.116562 C39.9378125,162.962813 20.7309375,162.962813 8.8846875,151.116562 L22.2534375,137.747813 C26.7171875,142.211562 33.95375,142.209375 38.4153125,137.747813 C42.8790625,133.284063 42.87875,126.049688 38.4153125,121.585937 L130.818438,29.1825 L143.56625,32.5965625 L158.033125,18.1296875 C162.048125,28.385 159.920313,40.4875 151.638125,48.769375 C143.354063,57.0534375 131.25125,59.1815625 120.998438,55.164375 L58.2890625,117.87375 C62.93875,128.904375 60.7709375,142.129687 51.7840625,151.116562 Z",
    id: "Path",
    fill: "#DDEEFA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DDEEFA",
    fillRule: "nonzero",
    points: "116.337188 109.707813 30.0546875 23.4253125 35.9965625 17.4834375 13.815625 0.0003125 0.0003125 13.8153125 17.48375 35.9965625 23.425625 30.054375 109.708125 116.336875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "113.0225 113.0225 6.9078125 6.9078125 0.0003125 13.8153125 17.48375 35.9965625 23.425625 30.054375 109.708125 116.336875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1878BD",
    points: "95.1371875 117.8 111.299062 133.961562 118.319375 133.866562 133.975 118.210938 133.961875 111.29875 117.8 95.1371875"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1878BD",
    points: "95.1371875 117.8 111.299063 133.961562 118.319375 133.866562 126.093125 126.092812 106.46875 106.468437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.299063,133.961563 L132.6425,155.305 C135.77375,158.43625 139.875,160.000625 143.97625,160.000625 C148.0775,160.000625 152.17875,158.43625 155.3075,155.307187 C161.565313,149.049375 161.565313,138.902187 155.305313,132.642187 L133.961875,111.29875 L111.299063,133.961563 Z",
    id: "Path",
    fill: "#329BE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.299063,133.961563 L132.6425,155.305 C135.77375,158.43625 139.875,160.000625 143.97625,160.000625 C148.0775,160.000625 152.17875,158.43625 155.3075,155.307187 L122.630313,122.630313 L111.299063,133.961563 Z",
    id: "Path",
    fill: "#329BE6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogin);
export default __webpack_public_path__ + "static/media/img-login.62bb6b7b5b80ccbc57de8d5aabdbb982.svg";
export { ForwardRef as ReactComponent };